module.exports = __webpack_public_path__ + "images/bioshock-infinite_rgba(0,0,0,0.7).jpg?v=4ec0a8140a5ee10573d0532b0cf09abd";